import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';

interface SaveComparePlansDisplayOrderParams {
  clientId: string;
  planIds: string[];
}

const saveComparePlansDisplayOrder = async ({
  clientId,
  planIds,
}: SaveComparePlansDisplayOrderParams): Promise<string[]> =>
  authFetch(`/Consumer/ComparePlan/SaveDisplayOrder?clientId=${clientId}`, {
    method: 'POST',
    ...httpBodyOptions({ planIds }, true),
  });

export const useSaveComparePlansDisplayOrderMutation = (clientId: string) => {
  const queryClient = useQueryClient();
  const queryKey = queryKeys.comparePlansDisplayOrder(clientId);

  return useMutation<string[], Error, string[]>(
    (planIds: string[]) => saveComparePlansDisplayOrder({ clientId, planIds }),
    {
      onSuccess: orderedPlanIds => {
        queryClient.setQueryData(queryKey, orderedPlanIds);
      },
    },
  );
};
